// =============================================
// 1. Cart Count Badge Updater
// =============================================
function updateCartCount() {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var countEl = document.querySelector('.site-header__cart-count');
      if (!countEl) return;
      countEl.textContent = cart.item_count;
      if (cart.item_count > 0) {
        countEl.removeAttribute('hidden');
        countEl.style.display = 'flex';
      } else {
        countEl.setAttribute('hidden', '');
        countEl.style.display = 'none';
      }
    });
}

// Wait for DOM to be fully ready before running
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
});

// =============================================
// 2. Cart Remove Button Fix
// =============================================
document.addEventListener('click', function(event) {
  var removeBtn = event.target.closest('[data-remove]');
  if (!removeBtn) return;

  event.preventDefault();
  removeBtn.disabled = true;
  removeBtn.textContent = 'Removing…';

  var lineItem = removeBtn.closest('[data-line]');
  var lineIndex = lineItem ? lineItem.getAttribute('data-line') : null;

  if (!lineIndex) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(lineIndex), quantity: 0 })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    window.location.reload();
  })
  .catch(function() {
    removeBtn.disabled = false;
    removeBtn.textContent = 'Remove';
    alert('Something went wrong. Please try again.');
  });
});
